import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import PrivacyPolicy from './PrivacyPolicy';
import ReturnRefundPolicy from './ReturnRefundPolicy';
import ShoppingPolicy from './ShoppingPolicy';
import TermsAndConditions from './TermsAndConditions';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <nav className="policy-nav">
          <Link to="/">Privacy Policy</Link>
          <Link to="/return-refund">Return & Refund</Link>
          <Link to="/shopping">Shopping Policy</Link>
          <Link to="/terms">Terms & Conditions</Link>
        </nav>

        <Routes>
          <Route path="/" element={<PrivacyPolicy />} />
          <Route path="/return-refund" element={<ReturnRefundPolicy />} />
          <Route path="/shopping" element={<ShoppingPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
